import React, {createContext, useState} from "react";

const _default = {
  appTitle: "",
  formsAD: [],
  formsAM: [],
  formsP: [],
  formADM: [],
  myInspections: [],
  allInspections: [],
  myInspectionsPending: false,
  allInspectionsPending: false,
  formOptions: {},
  session: null,
  online: true,
  formsCounter: 0,
  help: [],
  loading: false,
  platform: "web",
  profiles: [],
};

export const StoreContext = createContext(_default);

const StoreProvider = ({children}) => {
  const [appTitle, setAppTitle] = useState(_default.appTitle);
  const [formsAD, setFormsAD] = useState(_default.formsAD);
  const [formsAM, setFormsAM] = useState(_default.formsAM);
  const [formsP, setFormsP] = useState(_default.formsP);
  const [formsADM, setFormsADM] = useState(_default.formsADM);
  const [myInspections, setMyInspections] = useState(_default.myInspections);
  const [allInspections, setAllInspections] = useState(_default.allInspections);
  const [myInspectionsPending, setMyInspectionsPending] = useState(
    _default.myInspectionsPending
  );
  const [allInspectionsPending, setAllInspectionsPending] = useState(
    _default.allInspectionsPending
  );
  const [formOptions, setFormOptions] = useState(_default.formOptions);
  const [session, setSession] = useState(_default.session);
  const [online, setOnline] = useState(_default.online);
  const [help, setHelp] = useState(_default.help);
  const [loading, setLoading] = useState(_default.loading);
  const [platform, setPlatform] = useState(_default.platform);
  const [profiles, setProfiles] = useState(_default.profiles);

  const values = {
    appTitle,
    setAppTitle,
    formsAD,
    setFormsAD,
    formsAM,
    setFormsAM,
    myInspections,
    setMyInspections,
    formOptions,
    setFormOptions,
    session,
    setSession,
    online,
    setOnline,
    myInspectionsPending,
    setMyInspectionsPending,
    help,
    setHelp,
    loading,
    setLoading,
    formsP,
    setFormsP,
    formsADM,
    setFormsADM,
    platform,
    setPlatform,
    allInspections,
    setAllInspections,
    allInspectionsPending,
    setAllInspectionsPending,
    profiles,
    setProfiles,
  };

  return (
    <StoreContext.Provider value={values}>{children}</StoreContext.Provider>
  );
};

export default StoreProvider;
